var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card',{staticClass:"mb-12",attrs:{"color":"lighten-1"}},[_c('v-card-text',[_vm._v(" Po wygenerowaniu raport zostanie wysłany na Twój adres e-mail. ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }